import { useEffect, useState } from "react";
import { Dialog } from "@headlessui/react";
import { SettingsOutlined } from "@mui/icons-material";
import { useAuth } from "../context/AuthProvider"; // ✅ Import du contexte d'auth
import Administrateur from "../settings/pages/Administrateur";
import Affichage from "../settings/pages/Affichage";
import General from "../settings/pages/General";
import Langue from "../settings/pages/Langue";

export default function Settings() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState("general");

  // ✅ Récupère l'utilisateur et son rôle depuis le contexte Auth
  const { user } = useAuth();
  const userRole = user?.Rôle || "Utilisateur"; // ✅ Défaut à "Utilisateur" si non défini

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"; // Empêche le scroll
      document.querySelectorAll("body > *:not(.dialog-overlay)").forEach((el) => {
        el.style.filter = "blur(5px)";
      });
    } else {
      document.body.style.overflow = "";
      document.querySelectorAll("body > *").forEach((el) => {
        el.style.filter = "";
      });
    }

    return () => {
      document.body.style.overflow = "";
      document.querySelectorAll("body > *").forEach((el) => {
        el.style.filter = "";
      });
    };
  }, [isOpen]);

  const renderTabContent = () => {
    switch (selectedTab) {
      case "general":
        return <General />;
      case "display":
        return <Affichage />;
      case "language":
        return <Langue />;
      case "admin":
        return userRole === "Administrateur" ? <Administrateur /> : <General />; // ✅ Vérifie encore côté affichage
      default:
        return <General />;
    }
  };

  return (
    <>
      <button onClick={() => setIsOpen(true)} className="p-2 rounded-full hover:bg-gray-200 transition">
        <SettingsOutlined className="text-gray-700" sx={{ fontSize: 25 }} />
      </button>

      <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="relative z-50">
        {/* ✅ Ajout d'une classe pour exclure du flou */}
        <div className="fixed inset-0 bg-gray-500/75 backdrop-blur-md dialog-overlay" aria-hidden="true"></div>

        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel className="w-full max-w-3xl flex rounded-lg bg-white shadow-xl z-50 dialog-overlay">
            <div className="w-1/4 bg-gray-100 p-4 rounded-l-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Paramètres</h3>
              <ul className="space-y-2">
                <li>
                  <button
                    className={`w-full text-left px-3 py-2 rounded-md transition ${
                      selectedTab === "general" ? "bg-indigo-600 text-white" : "hover:bg-gray-200"
                    }`}
                    onClick={() => setSelectedTab("general")}
                  >
                    Général
                  </button>
                </li>
                <li>
                  <button
                    className={`w-full text-left px-3 py-2 rounded-md transition ${
                      selectedTab === "display" ? "bg-indigo-600 text-white" : "hover:bg-gray-200"
                    }`}
                    onClick={() => setSelectedTab("display")}
                  >
                    Affichage
                  </button>
                </li>
                <li>
                  <button
                    className={`w-full text-left px-3 py-2 rounded-md transition ${
                      selectedTab === "language" ? "bg-indigo-600 text-white" : "hover:bg-gray-200"
                    }`}
                    onClick={() => setSelectedTab("language")}
                  >
                    Langue
                  </button>
                </li>

                {/* ✅ L'onglet Administrateur n'est visible que pour les admins */}
                {userRole === "Administrateur" && (
                  <li>
                    <button
                      className={`w-full text-left px-3 py-2 rounded-md transition ${
                        selectedTab === "admin" ? "bg-red-600 text-white" : "hover:bg-gray-200"
                      }`}
                      onClick={() => setSelectedTab("admin")}
                    >
                      Administrateur
                    </button>
                  </li>
                )}
              </ul>
            </div>

            <div className="w-3/4 p-6">{renderTabContent()}</div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
}
